import React from "react";
import { Button } from "react-bootstrap";
import { hasPermission } from "../../hooks/usePermission";
import { HiEye, HiOutlinePencilAlt } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

function BookingTable({ bookings, startIndex = 0, onUpdateClick, isClientSide }) {
  const navigate = useNavigate();
  const canUpdate = hasPermission('bookings:update');

  const getStatusText = (status) => {
    if (status === 'S') return 'SUBMITTED';
    if (status === 'I') return 'IN-PROGRESS';
    if (status === 'C') return 'COMPLETED';
    return status || '-';
  };
  // Helper function to format date to DD/MM/YY
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(Date.parse(dateString));
      if (isNaN(date.getTime())) return '-';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);
      return `${day}/${month}/${year}`;
    } catch (error) {
      return '-';
    }
  };

  const getRecords = () => {
    return bookings.map((booking, index) => (
      <tr key={`${booking.booking_id}_${booking.sample_id}`}>
        <td data-label="S. NO.">{startIndex + index + 1}</td>
        <td data-label="BOOKING ID">{booking.booking_id}</td>
        <td data-label="SAMPLE ID">{booking.sample_id?.toUpperCase()}</td>
        <td data-label="SAMPLE NO">
          {booking.sample_no}
          {booking.samples_count ? `/${booking.samples_count}` : ""}
        </td>
        <td data-label="FARM NAME">{booking.farm_name?.toUpperCase()}</td>
        <td data-label="FARM SIZE">
          {booking.farm_size?.toUpperCase()}&nbsp;
          {booking.farm_size_unit?.toUpperCase()}
        </td>
        <td
          className="d-none d-lg-table-cell"
          data-label="PREVIOUS CROP"
        >
          {booking.previous_crop?.toUpperCase()}
        </td>
        <td
          className="d-none d-lg-table-cell"
          data-label="NEXT CROP"
        >
          {booking.next_crop?.toUpperCase()}
        </td>
        {isClientSide ? (
          <td data-label="COMMENTS">
            {booking.comments ? booking.comments?.toUpperCase() : "-"}
          </td>
        ) : (
          <td data-label="TEST PARTNER">
            {booking.source ? booking.source?.toUpperCase() : "-"}
          </td>
        )}
        <td data-label="TEST STATUS">
          {getStatusText(booking.sample_status)}
        </td>
        <td data-label="DATE">
          {formatDate(booking.created_at)}
        </td>
        <td data-label="ACTIONS">
          <div className="d-flex gap-2 justify-content-center">
            {/* VIEW BUTTON */}
            <Button 
              variant="info" 
              size="sm" 
              className="text-white d-flex align-items-center gap-1"
              onClick={() => navigate(`/bookings/view/${booking.booking_id}`)}
              title="View Details"
            >
              <HiEye /> View
            </Button>
            
            {/* EDIT BUTTON */}
            {canUpdate && (
              <Button 
                variant="primary" 
                size="sm" 
                className="d-flex align-items-center gap-1"
                onClick={() => onUpdateClick(booking)}
                title="Edit Sample"
              >
                <HiOutlinePencilAlt /> Edit
              </Button>
            )}
          </div>
        </td>
      </tr>
    ));
  };

  return (
    <div className="table-responsive">
      <table
        className={`table table-striped text-center table-borderless ${bookings.length > 1 ? "align-middle" : ""
          }`}
      >
        <thead className="table-dark align-top">
          <tr>
            <th>S. NO.</th>
            <th>BOOKING ID</th>
            <th>SAMPLE ID</th>
            <th>SAMPLE NO</th>
            <th>FARM NAME</th>
            <th>FARM SIZE</th>
            <th className="d-none d-lg-table-cell">PREVIOUS CROP</th>
            <th className="d-none d-lg-table-cell">NEXT CROP</th>
            {isClientSide ? <th>COMMENTS</th> : <th>TEST PARTNER</th>}
            <th>TEST STATUS</th>
            <th>DATE</th>
            {canUpdate && <th>ACTION</th>}
          </tr>
        </thead>
        <tbody>
          {bookings && bookings.length > 0 ? (
            getRecords()
          ) : (
            <tr>
              <td className="no-entries" colSpan={canUpdate ? "12" : "11"}>
                No Entries Found..
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default BookingTable;